import { type FC, type ReactNode } from 'react';

// components
import { Button, type ButtonProps } from 'dibs-elements/exports/Button';
import { FormattedMessage } from 'dibs-react-intl';

type Props = {
    className?: ButtonProps['className'];
    onClick: ButtonProps['onClick'];
    disabled?: ButtonProps['disabled'];
    label?: ReactNode;
    size?: ButtonProps['size'];
    type?: ButtonProps['type'];
};

export const PdpSharedAuctionBidButton: FC<Props> = props => {
    const { className, onClick, disabled, label, size = 'large', type = 'primary' } = props;

    return (
        <>
            <Button
                dataTn="pdp-item-actions-place-bid"
                type={type}
                fullWidth
                className={className}
                size={size}
                onClick={onClick}
                disabled={disabled}
            >
                {label ? (
                    <>{label}</>
                ) : (
                    <FormattedMessage
                        id="PdpSharedAuctionBidButton.placeBid"
                        defaultMessage="Place Bid"
                    />
                )}
            </Button>
        </>
    );
};
